<div (touchstart)="onTouchStart($event)"
  (touchend)="onTouchEnd($event)">
  <ng-content></ng-content>
</div>
